/**
 * PATH: apps/qa/src/lib/api/ai.ts
 * PURPOSE: AI-powered analysis endpoints (DeepSeek)
 */

import { api } from './helpers'

export const aiApi = {
  analyzeEvidence: async (inspectionId: string, evidenceIds?: string[]) => {
    const r = await api().post('/qa/ai/analyze-evidence/', { inspection_id: inspectionId, evidence_ids: evidenceIds })
    return r.data
  },
  checkReadiness: async (inspectionId: string) => {
    const r = await api().post('/qa/ai/check-readiness/', { inspection_id: inspectionId })
    return r.data
  },
  suggestItems: async (templateId: string, sectionName: string, existingItems?: string[]) => {
    const r = await api().post('/qa/ai/suggest-items/', { template_id: templateId, section_name: sectionName, existing_items: existingItems })
    return r.data
  },
  fixText: async (text: string): Promise<{ fixed_text: string }> => {
    const r = await api().post('/qa/ai/fix-text/', { text })
    return r.data
  },
}
